import React from 'react';
import IconCalendar from 'Icon/svg/Calendar';
import DatePicker, { registerLocale } from 'react-datepicker';
import id from 'date-fns/locale/id';

import 'react-datepicker/dist/react-datepicker.css';
import { string } from 'prop-types';

registerLocale('id', id);

const CustomInput = ({ value, onClick }) => (
  <div className="datepicker-button-container" onClick={onClick}>
    {value}
    <div className="icon">
      <IconCalendar />
    </div>
  </div>
);

const DatePickerObj = ({ dateFormat, ...rest }) => (
  <DatePicker
    locale="id"
    dateFormat={dateFormat}
    popperPlacement="bottom-end"
    dropdownMode="select"
    autoComplete="off"
    showMonthDropdown
    showYearDropdown
    customInput={<CustomInput />}
    {...rest}
  />
);

DatePickerObj.propTypes = {
  dateFormat: string,
};

DatePickerObj.defaultProps = {
  dateFormat: 'dd MMMM yyyy',
};

export default DatePickerObj;
